/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Shift_Event_ForwardInputs */



/**
* | output |
* | --- |
* | "Shift the selected event(s) forward by one frame" |
*
* @param {Shortcut_Keys_Desc_Shift_Event_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_shift_event_forward = /** @type {((inputs?: Shortcut_Keys_Desc_Shift_Event_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Shift_Event_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler les evenements selectionnes d'une image vers l'avant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe das/die ausgewählte(n) Ereignis(se) um ein Frame nach vorne.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta in avanti di un fotogramma l'evento/gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть выбранное событие (события) на один кадр вперед.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar el evento(s) seleccionado(s) hacia adelante un cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件向前移动一帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを1フレーム前に移動します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को एक फ्रेम आगे खिसकाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque o(s) evento(s) selecionado(s) um quadro para a frente.")
	return /** @type {LocalizedString} */ ("Shift the selected event(s) forward by one frame")
});